import type { RuleDefinition } from '../ruleRegistry';

/**
 * PBL-reformen 1 december 2025: friggebod (15 m²) och attefallshus
 * (30 m² + anmälan) slogs ihop till "bygglovsbefriad komplementbyggnad".
 * Anmälningsplikt och startbesked för själva byggnaden är avskaffade;
 * eldstadsanmälan, 4,5 m-gränsen mot tomtgräns och strandskydd gäller fortfarande.
 * Gäller endast `se`-marknaden — intl-flödet använder generiska trösklar.
 */
export const PERMIT_RULES = [
    {
        id: 'permit.se.exemptMaxAreaDetaljplanM2',
        category: 'permit',
        label: 'Max byggnadsarea inom detaljplan',
        description: 'Största byggnadsarea per bygglovsbefriad komplementbyggnad inom detaljplanelagt område.',
        defaultValue: 30,
        valueType: 'number',
        unit: 'm²',
        source: 'PBL-reform 1 december 2025 (Boverket: nytt regelverk för bygglov)',
        dangerLevel: 'critical',
    },
    {
        id: 'permit.se.exemptTotalAreaDetaljplanM2',
        category: 'permit',
        label: 'Max samlad area inom detaljplan',
        description: 'Största sammanlagda byggnadsarea för alla bygglovsbefriade komplementbyggnader per tomt inom detaljplan.',
        defaultValue: 45,
        valueType: 'number',
        unit: 'm²',
        source: 'PBL-reform 1 december 2025 (Boverket: nytt regelverk för bygglov)',
        dangerLevel: 'critical',
    },
    {
        id: 'permit.se.exemptMaxAreaOutsideDetaljplanM2',
        category: 'permit',
        label: 'Max byggnadsarea utanför detaljplan',
        description: 'Största byggnadsarea per bygglovsbefriad komplementbyggnad utanför detaljplanelagt område.',
        defaultValue: 50,
        valueType: 'number',
        unit: 'm²',
        source: 'PBL-reform 1 december 2025 (Boverket: nytt regelverk för bygglov)',
        dangerLevel: 'critical',
    },
    {
        id: 'permit.se.exemptTotalAreaOutsideDetaljplanM2',
        category: 'permit',
        label: 'Max samlad area utanför detaljplan',
        description: 'Största sammanlagda byggnadsarea för alla bygglovsbefriade komplementbyggnader per tomt utanför detaljplan.',
        defaultValue: 65,
        valueType: 'number',
        unit: 'm²',
        source: 'PBL-reform 1 december 2025 (Boverket: nytt regelverk för bygglov)',
        dangerLevel: 'critical',
    },
    {
        id: 'permit.se.exemptMaxRidgeHeightM',
        category: 'permit',
        label: 'Max nockhöjd',
        description: 'Högsta nockhöjd för en bygglovsbefriad komplementbyggnad.',
        defaultValue: 4.5,
        valueType: 'number',
        unit: 'm',
        source: 'PBL-reform 1 december 2025 (Boverket: nytt regelverk för bygglov)',
        dangerLevel: 'critical',
    },
] as const satisfies readonly RuleDefinition[];
